import { Link } from 'react-router-dom';
import Arrow from '../../components/ui/Arrow';
import { localizedPath, useLocale, useMessages } from '../../i18n/locale';

export default function ContactPage() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.contactPage;
  return (
    <main className="module-page company-page company-page--business">
      <section className="module-hero module-hero--contact">
        <div className="module-hero__grid" aria-hidden="true" />
        <div className="container module-hero__inner">
          <div className="module-hero__copy">
            <div className="module-breadcrumb">
              <Link to={localizedPath(locale)}>{messages.modulePage.home}</Link>
              <span>/</span>
              <Link to={localizedPath(locale, '/company')}>{copy.about}</Link>
              <span>/</span>
              <span>{copy.name}</span>
            </div>
            <div className="module-eyebrow">
              <span className="module-eyebrow__dot" /> {copy.eyebrow}
            </div>
            <h1>
              <span>{copy.title[0]}</span>
              <span className="module-hero__muted">{copy.title[1]}</span>
            </h1>
            <p>{copy.description}</p>
            <div className="module-hero__actions">
              <Link className="button button--primary" to={localizedPath(locale, '/company')}>
                {copy.aboutUs} <Arrow up />
              </Link>
            </div>
          </div>
          <div className="module-art" aria-hidden="true">
            <div className="module-art__ring module-art__ring--outer" />
            <div className="module-art__ring module-art__ring--inner" />
            <div className="module-art__core">
              <span>✳</span>
              <small>{copy.artLabel}</small>
            </div>
          </div>
        </div>
      </section>
      <section className="company-business container">
        <header className="company-business__heading">
          <span className="company-eyebrow">{copy.eyebrow}</span>
          <h2>{copy.servicesTitle}</h2>
        </header>
        <div className="company-business__services">
          {copy.services.map((service, index) => (
            <article className="company-business__service" key={service.title}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <i aria-hidden="true">↗</i>
            </article>
          ))}
        </div>
        <p className="company-business__note">{copy.contactNote}</p>
      </section>
    </main>
  );
}
